import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { PaymentRequestGroupContent } from './PaymentRequestGroupContent';
import { EventUtil, Poller } from '@as-react/common-utils';
import { DELAY } from '../../../constants/GeneralConstants';
import { EventEnum, SaferpayFieldsBancontactAppOptionsState, } from '@as-react/common-types';
import { useAemConfig } from '@as-react/common-components';
import AsNumeral from '../../../vendors/asNumeral';
import { useSaferpay } from '../../../hooks/useSaferpay';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useTranslation } from 'react-i18next';
import { BancontactForm } from '../payment/payment-groups/forms/BancontactForm';
const MAX_BASKET_TOTAL_FOR_APP = 500;
const BANCONTACT_PAYMENT_METHODS = ['bancontact'];
let timers = [];
export const PaymentRequestGroupBancontact = ({ selected, group, totalPrice, onInitAlternative, onPollingAlternative, onSubmit, }) => {
    const paymentGroupContentRef = useRef();
    const { t } = useTranslation(I18N_NAMESPACES.buy);
    const [isTimerRun, setIsTimerRun] = useState(false);
    const hasAppOptions = (totalPrice && totalPrice <= MAX_BASKET_TOTAL_FOR_APP) || false;
    const [appOptionsState, setAppOptionsState] = useState(SaferpayFieldsBancontactAppOptionsState.LOADING);
    const [qrCodeImage, setQrCodeImage] = useState('');
    const [intentUrl, setIntentUrl] = useState('');
    const [inited, setInited] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showError, setShowError] = useState(false);
    const { currency } = useAemConfig();
    const { hasError: hasSaferpayError, validation } = useSaferpay({
        paymentMethods: BANCONTACT_PAYMENT_METHODS,
        enabled: selected,
    });
    const endTimers = () => {
        timers.forEach(timer => timer.end());
        timers = [];
    };
    const startAppPaymentTimer = (expiration) => {
        const expirationDate = new Date(expiration).getTime();
        const paymentTimer = new Poller(() => {
            const currentTime = Date.now();
            if (currentTime > expirationDate) {
                return true;
            }
            return false;
        }, DELAY.DELAY_1000);
        paymentTimer.run().then(() => {
            if (paymentTimer && paymentTimer.active) {
                setAppOptionsState(SaferpayFieldsBancontactAppOptionsState.DISABLED);
            }
        });
        timers.push(paymentTimer);
        setIsTimerRun(true);
    };
    const startPollingForAppPayment = (requestId) => {
        const paymentPoller = new Poller(() => __awaiter(void 0, void 0, void 0, function* () { return onPollingAlternative === null || onPollingAlternative === void 0 ? void 0 : onPollingAlternative(requestId); }), DELAY.DELAY_2000);
        paymentPoller.run().then((redirectUrl) => {
            if (redirectUrl) {
                location.href = redirectUrl;
            }
        });
        timers.push(paymentPoller);
        setIsTimerRun(true);
    };
    const initBancontactPayment = () => __awaiter(void 0, void 0, void 0, function* () {
        endTimers();
        setQrCodeImage('');
        setIntentUrl('');
        setAppOptionsState(SaferpayFieldsBancontactAppOptionsState.LOADING);
        try {
            const result = yield (onInitAlternative === null || onInitAlternative === void 0 ? void 0 : onInitAlternative());
            endTimers();
            if (result) {
                startAppPaymentTimer(result.expiration);
                startPollingForAppPayment(result.requestId);
                setQrCodeImage(result.qrCodeImage);
                setIntentUrl(result.intentUrl);
            }
            setAppOptionsState(SaferpayFieldsBancontactAppOptionsState.ENABLED);
        }
        catch (_a) {
            setAppOptionsState(SaferpayFieldsBancontactAppOptionsState.DISABLED);
        }
    });
    const handleSubmit = () => {
        setIsSubmitting(true);
        setShowError(false);
        window.SaferpayFields.submit({
            onSuccess: ({ token }) => {
                try {
                    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(token);
                }
                catch (_a) {
                    setIsSubmitting(false);
                    setShowError(true);
                }
            },
            onError: () => {
                setIsSubmitting(false);
            },
        });
    };
    const handleVoucherChange = () => {
        selected && hasAppOptions && initBancontactPayment();
    };
    useEffect(() => {
        if (!inited && hasAppOptions) {
            setInited(true);
            initBancontactPayment();
        }
        else {
            endTimers();
        }
        EventUtil.listen(EventEnum.VOUCHER_CHANGED, handleVoucherChange);
        return () => {
            EventUtil.remove(EventEnum.VOUCHER_CHANGED, handleVoucherChange);
        };
    }, [selected, hasAppOptions]);
    useEffect(() => {
        return () => {
            isTimerRun && endTimers();
        };
    }, [isTimerRun]);
    return (_jsx(PaymentRequestGroupContent, { group: group, selected: selected, onSubmit: handleSubmit, error: !!hasSaferpayError || showError ? t(`buy.payment.form.error`) : undefined, disabled: !!hasSaferpayError || showError, isSubmitting: isSubmitting, innerRef: paymentGroupContentRef, children: selected && (_jsx(BancontactForm, { appOptionsState: appOptionsState, currency: currency, hasAppOptions: hasAppOptions, intentUrl: intentUrl, paymentMethods: BANCONTACT_PAYMENT_METHODS, priceTotalBasket: totalPrice ? AsNumeral.formatAsCurrency(totalPrice) : '', qrCodeImage: qrCodeImage, validation: validation })) }));
};
